import { Controller } from "@hotwired/stimulus"
import { openCrispChat, syncCrispWithOpenOverlays } from "../utils/hide_crisp_on_modals"

// Onglet Chat de la barre du bas sur téléphone (Shared::LayoutComponents::MobileNavbarComponent) :
// ouvre Crisp, dont la bulle est masquée tant que l'onglet est affiché, et montre ses messages
// non lus.
export default class extends Controller {
  static targets = ["badge"]

  connect() {
    this.onUnread = (event) => this.render(event.detail.count)
    document.addEventListener("crisp:unread-count", this.onUnread)
    this.render(window.__crispUnreadCount || 0)
    syncCrispWithOpenOverlays()
  }

  disconnect() {
    document.removeEventListener("crisp:unread-count", this.onUnread)
  }

  open() {
    openCrispChat()
  }

  render(count) {
    if (!this.hasBadgeTarget) return

    this.badgeTarget.hidden = count <= 0
    this.badgeTarget.textContent = count > 9 ? "9+" : String(count)
  }
}
